import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Check } from 'lucide-react';
export function OfferStack() {
  const stack = [{
    icon: '🌿',
    name: 'Guía Maestra S.O.S.',
    value: '$37 USD',
    desc: 'El protocolo completo paso a paso — de 15 minutos — para ir del colapso al silencio mental esta noche'
  }, {
    icon: '🍵',
    name: 'Recetario de 7 Elixires',
    value: '$27 USD',
    desc: '7 preparaciones exactas con dosis de impacto real — infusiones y tinturas que SÍ funcionan'
  }, {
    icon: '🛒',
    name: 'Checklist: Tu Botiquín de $5 USD',
    value: '$17 USD',
    desc: 'La lista exacta de lo que compras en tu supermercado. Sin marcas caras. Sin farmacias especializadas.'
  }, {
    icon: '📄',
    name: 'BONO: Hoja de Vaciado Mental',
    value: '$17 USD',
    desc: 'El ejercicio de 3 minutos que descarga tus preocupaciones del cerebro al papel — para no llevarlas a la cama',
    isBonus: true
  }];
  return <section className="px-6 py-10 max-w-4xl mx-auto" data-id="element-100">
      <FadeIn data-id="element-101">
        <div className="bg-[#4A5D3A] rounded-3xl p-1 md:p-2 shadow-2xl" data-id="element-102">
          <div className="bg-[#FAF6F0] rounded-[22px] p-6 md:p-12" data-id="element-103">
            <h2 className="text-3xl md:text-4xl font-serif font-bold text-center text-[#4A5D3A] mb-8" data-id="element-104">
              TODO LO QUE RECIBES POR $6.39 USD:
            </h2>

            <div className="space-y-3 mb-10" data-id="element-105">
              {stack.map((item, index) => <div key={index} className={`flex flex-col md:flex-row gap-4 p-6 rounded-xl border ${item.isBonus ? 'bg-[#C4A265]/10 border-[#C4A265]/30' : 'bg-white border-[#4A5D3A]/10'}`} data-id="element-106">
                  <div className="flex items-center gap-4 md:w-1/3" data-id="element-107">
                    <span className="text-3xl" data-id="element-108">{item.icon}</span>
                    <div data-id="element-109">
                      {item.isBonus && <span className="text-xs font-bold text-[#9B4F2B] uppercase tracking-wider block mb-1" data-id="element-110">
                          Bono Exclusivo
                        </span>}
                      <h3 className="font-bold text-lg text-[#2D2A26]" data-id="element-111">
                        {item.name}
                      </h3>
                    </div>
                  </div>
                  <div className="md:w-2/3 flex flex-col md:flex-row md:items-center gap-2 md:gap-6" data-id="element-112">
                    <p className="text-[#2D2A26]/80 text-sm md:text-base flex-grow" data-id="element-113">
                      {item.desc}
                    </p>
                    <span className="font-bold text-[#4A5D3A] whitespace-nowrap bg-[#4A5D3A]/10 px-3 py-1 rounded-full text-sm self-start md:self-auto" data-id="element-114">
                      Valor: {item.value}
                    </span>
                  </div>
                </div>)}
            </div>

            <div className="bg-white rounded-2xl p-8 border-2 border-[#4A5D3A] max-w-md mx-auto text-center relative overflow-hidden" data-id="element-115">
              <div className="absolute top-0 left-0 w-full h-2 bg-[#4A5D3A]" data-id="element-116"></div>
              <h3 className="font-serif text-2xl font-bold text-[#2D2A26] mb-6" data-id="element-117">
                RESUMEN DE VALOR
              </h3>

              <div className="space-y-3 text-lg mb-6" data-id="element-118">
                <div className="flex justify-between items-center text-[#2D2A26]/60" data-id="element-119">
                  <span data-id="element-120">Valor Total del Bundle</span>
                  <span className="line-through decoration-red-500/50 decoration-2" data-id="element-121">
                    $98 USD
                  </span>
                </div>
                <div className="flex justify-between items-center font-bold text-2xl text-[#4A5D3A] py-2 border-y border-gray-100" data-id="element-122">
                  <span data-id="element-123">Tu inversión hoy</span>
                  <span data-id="element-124">$6.39 USD</span>
                </div>
                <div className="flex justify-between items-center text-[#9B4F2B] font-medium" data-id="element-125">
                  <span data-id="element-126">Lo que ahorras</span>
                  <span data-id="element-127">$91.61 USD</span>
                </div>
              </div>

              <p className="italic text-[#2D2A26]/80 text-sm md:text-base bg-[#FAF6F0] p-4 rounded-lg" data-id="element-128">
                "Menos que un café con leche. Más poderoso que tres meses de
                intentar 'relajarte' sola."
              </p>
            </div>

            <div className="text-center mt-10" data-id="element-129">
              <a href="https://pay.hotmart.com/Y104754180A" className="inline-block w-full max-w-lg mx-auto text-center bg-[#4A5D3A] text-[#FAF6F0] font-bold py-5 px-8 rounded-xl shadow-lg hover:bg-[#3a4a2e] transition-colors text-lg md:text-xl mb-4" data-id="element-130">
                ACCEDER AHORA POR SOLO $6.39
              </a>
              <p className="text-sm text-[#2D2A26]/60 font-medium" data-id="element-131">
                🔒 Pago Seguro · ⚡ Acceso Inmediato
              </p>
            </div>
          </div>
        </div>
      </FadeIn>
    </section>;
}